import classes from './Form.module.scss';

import { useForm } from 'react-hook-form';

import { contactUsService } from 'services/static';

import { useMutation } from 'react-query';

import TextInput from '@core/components/textinput/TextInput';
import TextArea from '@core/components/textarea/TextArea';

import UseToast from 'hooks/use-toast';

const Form = () => {
	const { ToastContainer, toast } = UseToast();

	const { mutate } = useMutation('contact-us', contactUsService, {
		onSuccess: () => {
			toast('Your message has been sent successfully');
			reset();
		}
	});

	const {
		register,
		handleSubmit,
		formState: { errors, isDirty, isValid },
		reset
	} = useForm({ mode: 'onChange' });

	const submitForm = (e) => mutate(e);
	return (
		<>
			<ToastContainer />
			<form
				className={`${classes['form-container']} col-12 mx-auto mt-3 mb-5 col-xl-8 d-flex justify flex-column`}
				onSubmit={handleSubmit(submitForm)}>
				<p>
					To contact Pharmuni with any comment, feedback, or question of yours,
					you can send us an email to <a href="mailto:info@pharmuni.com">info@pharmuni.com</a>. Alternatively,
					you can also leave us a message here. If needed, we will contact you by sending an email.
				</p>
				<TextInput
					validation={{
						required: true
					}}
					input={{
						type: 'text',
						label: 'Subject',
						name: 'subject',
						id: 'subject'
					}}
					errors={errors}
					register={register}
				/>
				<TextArea
					validation={{
						required: true
					}}
					input={{
						label: 'Body',
						name: 'text',
						id: 'body'
					}}
					errors={errors}
					register={register}
				/>
				<p className={classes['confirm-text']}>
					By clicking on send you agree to our terms and conditions and privacy policy.
				</p>
				<button type="submit" className="w-100" disabled={!isDirty || !isValid}>
					Submit
				</button>
			</form>
		</>
	);
};

export default Form;
